
































































import Vue from "vue";
import fbsdk from "../../../facebookSdk";
import FBService from "../../../services/facebook";

import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
import { State, Mutation } from "vuex-class";

type Account = {
  id: string;
  account_id: string;
  name: string;
};

const namespace = "facebook";

@Component
export default class Facebook extends Vue {
  @State("facebook") facebook: FacebookState;
  @Mutation("unSelectCampaign", { namespace }) unSelectCampaign: any;
  @Mutation("unSelectAllCampaign", { namespace }) unSelectAllCampaign: any;

  fbLogin: null;
  me: { name: null };
  accounts: [];

  async created() {
    await fbsdk;
    window.FB.getLoginStatus(this.applyAuth);
    window.FB.Event.subscribe("auth.login", this.applyAuth);
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next();
  }

  applyAuth({ authResponse, status }: any) {
    if (status === "connected") {
      // this.fbLogin = authResponse;
      FBService.setAuthToken(authResponse.accessToken);
      this.$store.commit("facebook/auth", authResponse);
      // this.fetchMe();
      // this.listAccounts();
    }
  }
}
